// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import { docodeHexResponse } from '../../../_common/common.utils';
import OfficialDetailsActionType from './official-details.types';

const INITIAL_STATE = {
	officialDetailsResponse: null,
	economicActivityListResponse: null,
	economicActivityListData: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** Official Details Add Start ************************/
		case OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_SUCCESS:
			return { ...state, officialDetailsResponse: action.payload };

		case OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_FAILURE:
			return { ...state, officialDetailsResponse: action.payload };

		case OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_RESPONSE_CHANGED:
			return { ...state, officialDetailsResponse: null };

		/** ***************** Official Details Add Start ************************/

		/** ***************** Economic Activity List Start ************************/
		case OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_SUCCESS:
			return {
				...state,
				economicActivityListResponse: action.payload,
				economicActivityListData: docodeHexResponse(
					action.payload,
					'FetchAllEconomicActivityListKey',
				),
			};

		case OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_FAILURE:
			return { ...state, economicActivityListResponse: action.payload };

		case OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_RESPONSE_CHANGED:
			return { ...state, economicActivityListResponse: null };

		/** ***************** Economic Activity List End ************************/

		default:
			return state;
	}
};
